import React, { useState } from "react";
import PublicLayout from "../../components/PublicLayout";
import { FaCompass, FaLightbulb, FaUsers, FaCheckCircle, FaArrowRight, FaTimes } from "react-icons/fa";
import { addFromWaitlistPage } from '../../services/waitlist';
import './WaitlistPage.css';

const SuccessPopup = ({ isOpen, onClose, email }) => {
  if (!isOpen) return null;

  return (
    <div className="success-popup-overlay" onClick={onClose}>
      <div className="success-popup" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        
        <div className="popup-content">
          <div className="success-icon-container">
            <FaCheckCircle className="popup-success-icon" />
          </div>
          
          <h2 className="popup-title">Welcome to the Future!</h2>
          
          <p className="popup-message">
            Thank you for joining the Velox AI waitlist. You're now part of an exclusive group of forward-thinking sales professionals.
          </p>
          
          <div className="confirmation-details">
            <div className="email-confirmation">
              <span className="confirmation-label"> Confirmed:</span>
              <span className="confirmation-email">{email}</span>
            </div>
          </div>
          
          <p className="popup-footer">
            We'll keep you updated on our progress and notify you the moment we're ready to launch.
          </p>
          
          <button className="popup-close-button" onClick={onClose}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

const WaitlistPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check for company email
    const personalDomains = ['gmail.com', 'outlook.com', 'yahoo.com', 'hotmail.com', 'aol.com', 'icloud.com', 'protonmail.com'];
    const emailDomain = email.split('@')[1];
    
    if (!email || !email.includes("@") || !name) {
      alert("Please enter a valid name and email address.");
      return;
    }
    
    if (emailDomain && personalDomains.includes(emailDomain.toLowerCase())) {
      alert("Please use a company email address. We do not accept personal email addresses (Gmail, Outlook, etc.).");
      return;
    }

    setIsLoading(true);

    try {
      // Add user to waitlist database
      await addFromWaitlistPage(name, email);
      
      setShowSuccessPopup(true);
      setSubmittedEmail(email); // Store the submitted email
      // Reset form after successful submission
      setName("");
      setEmail("");
    } catch (error) {
      console.error('Waitlist signup error:', error);
      alert("There was an error adding you to the waitlist. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PublicLayout>
      {/* Hero Section */}
      <section className="hero-section waitlist-hero">
        <div className="waitlist-container">
          <div className="waitlist-hero-content text-center">
            <h1>The Future of B2B Sales Enablement is Here</h1>
            <p className="hero-subtitle">
              Research Less, Close More.
            </p>
          </div>
        </div>
        <div className="waitlist-form-container">
          <div className="waitlist-form-wrapper">
            <h2 className="waitlist-section-title">Join the Waitlist</h2>
            <p className="waitlist-section-subtitle">
              Join the waitlist and be the first to know when we launch.
            </p>
            
            <form onSubmit={handleSubmit} className="waitlist-form">
              <div className="form-row">
                <input
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className="join-waitlist-btn"
              >
                {isLoading ? (
                  <span className="loading-text">
                    <div className="spinner"></div>
                    Joining...
                  </span>
                ) : (
                  <span>
                    Join Waitlist 
                    <FaArrowRight className="arrow-icon" />
                  </span>
                )}
              </button>
            </form>
            
            <p className="privacy-note">
              🔒 Your email is safe with us. No spam, just exclusive updates.
            </p>
          </div>
        </div>
      </section>
      
      {/* Custom Success Popup */}
      <SuccessPopup 
        isOpen={showSuccessPopup} 
        onClose={() => setShowSuccessPopup(false)} 
        email={submittedEmail}
      />
    </PublicLayout>
  );
};

export default WaitlistPage; 